export default async function initContrastToggle() {
  const element = document.querySelector('[data-js-module="contrast-toggle"]');

  if (element) {
    const { default: ContrastToggle } = await import(/* webpackChunkName: "contrast-toggle" */ './contrast-toggle');
    new ContrastToggle(element);
  }
}
